import { observable, action } from 'mobx';
import { emit, events } from '@estee/elc-service-bus';
import { KEYDOWN, ESCAPE_KEY } from '~constants/Keys';
import { ProductImageEventAction, ProductImageEventLabel } from '~constants/ProductImage';

export class ZoomViewBaseController {
    @observable public isZoomActive: boolean = false;
    @observable public currentZoomSlideIndex: number = 0;

    @action
    private setZoom = (isActive: boolean) => {
        this.isZoomActive = isActive;
    };

    @action
    public setCurrentZoomSlideIndex = (currentZoomSlideIndex: number = 0) => {
        this.currentZoomSlideIndex = currentZoomSlideIndex;
    };

    private handleKeyPressed = (event: KeyboardEvent) => {
        if (event.key === ESCAPE_KEY) {
            this.closeZoom();
        }
    };

    private setZoomStatus = (zoomStatus: boolean, eventLabel: string) => {
        this.setZoom(zoomStatus);
        emit(events.PRODUCT_IMAGE_ZOOM_TRIGGERED,  { eventAction: ProductImageEventAction.ZOOM, eventLabel });
    };

    public openZoom = () => {
        document.addEventListener(KEYDOWN, this.handleKeyPressed);
        this.setZoomStatus(true, ProductImageEventLabel.OPEN );
    };

    public closeZoom = () => {
        document.removeEventListener(KEYDOWN, this.handleKeyPressed);
        this.setZoomStatus(false, ProductImageEventLabel.CLOSE );
    };
}
